import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  arrayOf,
  objectOf,
  any,
  func,
  oneOf,
} from 'prop-types';
import {
  Card,
  List,
  Typography,
  withWidth,
} from '@material-ui/core';
import ListItemCard from '../shared/ListItemCard';
import SelectableChipWithCount from '../shared/SelectableChipWithCount';
import SelectableChip from '../shared/SelectableChip';
import * as Routes from '../../services/routes/Routes.json';
import { getNotifications } from '../../selectors';
import { checkForNotifications } from '../../services/helpers/CustomHooks';
import '../../css/notificationsPageV2/NotificationsPageV2.scss';
import DateHelper from '../../services/helpers/DateHelper';
import { CHIP } from '../../services/constants/Constants';
import * as Functions from '../../services/functions/Functions';
import CloseButtonComponent from '../core/components/CloseButton';
import NotificationActionSheet from './components/NotificationActionSheet';
import useIsTablet from '../../shared/hooks/useIsTablet';

const getSelectedChipTitle = (selectedChip, translation) => {
  switch (selectedChip) {
    case CHIP.new:
      return translation('NotificationsPageV2.new');
    case CHIP.read:
      return translation('NotificationsPageV2.read');
    default:
      return '';
  }
};

const NotificationsComponent = (props) => {
  const {
    history,
    user,
    translation,
    upliftHistory,
    notifications,
    width,
  } = props;
  const [selectedChip, setSelectedChip] = useState(CHIP.new);
  const [notificationId, setNotificationId] = useState(null);
  const isMobile = Functions.isMobileV2(width);
  const isTablet = useIsTablet();

  useEffect(() => {
    if (typeof upliftHistory === 'function' && history) upliftHistory(history);
  }, []);

  if (!user) {
    history.push(Routes.path.menuPage);
    return null;
  }

  checkForNotifications(user);

  const [selectedNotification, setSelectedNotification] = useState(null);
  const [isSingleViewOpen, setIsSingleViewOpen] = useState(false);
  const handleNotificationClick = (notification) => {
    setSelectedNotification(notification);
    setNotificationId(notification.id);
    setIsSingleViewOpen(true);
  };

  return (
    <div className="notificationsPageV2-container">
      <div className="notificationsPageV2-header">
        <Typography className="notificationsPageV2-title">
          {translation('NotificationsPageV2.title')}
        </Typography>
        <CloseButtonComponent handleButtonClose={() => history.goBack()} />
      </div>
      <div className="notificationsPageV2-pageContent">
        <div className="notificationsPageV2-pageContainer">
          <div className="notificationsPageV2-chip-container">
            <SelectableChipWithCount
              label={translation('NotificationsPageV2.new')}
              count={25} // will update this with the actual count when filtering enabled
              isSelected={selectedChip === CHIP.new}
              onClick={() => setSelectedChip(CHIP.new)}
            />
            <SelectableChip
              label={translation('NotificationsPageV2.read')}
              isSelected={selectedChip === CHIP.read}
              onClick={() => setSelectedChip(CHIP.read)}
            />
          </div>
          <Typography className="notificationsPageV2-chipTitle">
            {getSelectedChipTitle(selectedChip, translation)}
          </Typography>
          <List className="notificationsPageV2-listContainer">
            {
              notifications.map(notification => (
                <div key={notification.id}>
                  <ListItemCard
                    key={notification.id}
                    title={notification.subject}
                    body={notification.messageBody}
                    date={DateHelper.getFormattedNotificationDate(notification, translation)}
                    imageURL={notification.imageURL}
                    isSelected={notificationId === notification.id}
                    isRead={notification.isRead}
                    onClick={() => handleNotificationClick(notification)}
                  />
                </div>
              ))
            }
          </List>
        </div>
        <div className="notificationsPageV2-gap" />
        <div className="notificationsPageV2-pageContainer">
          <Card>
            Notification Content
          </Card>
        </div>
      </div>
      {
        (isMobile || isTablet)
        && (
          <NotificationActionSheet
            isOpen={isSingleViewOpen}
            width={width}
            setIsOpen={setIsSingleViewOpen}
            notification={selectedNotification}
            translation={translation}
          />
        )
      }
    </div>
  );
};

NotificationsComponent.propTypes = {
  translation: func.isRequired,
  history: objectOf(any).isRequired,
  upliftHistory: func.isRequired,
  user: objectOf(any),
  notifications: arrayOf(objectOf(any)),
  width: oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
};

NotificationsComponent.defaultProps = {
  user: null,
  notifications: [],
};

const mapStateToProps = state => ({
  notifications: getNotifications(state),
});

const mapDispatchToProps = () => ({});

const NotificationsPage = compose(connect(mapStateToProps, mapDispatchToProps))(withRouter(withWidth()(NotificationsComponent)));

export default NotificationsPage;
